import { useLayoutEffect as useBrowserLayoutEffect, useEffect } from 'react';

const useLayoutEffect =
  typeof window !== 'undefined' ? useBrowserLayoutEffect : useEffect;

export { useLayoutEffect };
